import { VENTES_AVENUES } from '@/enums/retargeting'
import { generateRetargetingCookieName } from '@/utils/retargeting'
import { getCookieDomain } from '@/utils/cookie'
import { CookieDuration } from '@/enums/gtm'
import { defineNuxtRouteMiddleware, useCookie } from 'nuxt/app'

export default defineNuxtRouteMiddleware((to) => {
  const retargetingParam = to.query.ret

  if (retargetingParam === VENTES_AVENUES) {
    const cookie = useCookie(generateRetargetingCookieName(VENTES_AVENUES), { expires: new Date(Date.now() + CookieDuration), path: '/', domain: getCookieDomain() })
    cookie.value = 'set'
  }
})
